import o from "./index.es414.js";
import r from "./index.es415.js";
import t from "./index.es416.js";
const l = {
  isBrowser: !0,
  classes: {
    URLSearchParams: o,
    FormData: r,
    Blob: t
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  l as default
};
//# sourceMappingURL=index.es352.js.map
